// Combine a date object with a "HH:mm" time string into a single Date.
export const combineDateAndTime = (date, time) => {
    if (!date || !time) return null;
    const [hours, minutes] = time.split(':');
    const newDate = new Date(date);
    newDate.setHours(parseInt(hours, 10), parseInt(minutes, 10), 0, 0);
    return newDate;
};

const minutesOfDay = (time) => {
    const [hours, minutes] = time.split(':');
    return parseInt(hours, 10) * 60 + parseInt(minutes, 10);
};

export const BATCH_SEND_ERROR =
    "Start date/time must be in the future, and the daily sending window must be at least 1 hour.";

// Batch sends deliver one batch per hour between start time and end time each day,
// so the daily window has to fit at least one send.
export const isBatchSendValid = (startDate, startTime, endDate, endTime) => {
    const start = combineDateAndTime(startDate, startTime);
    const end = combineDateAndTime(endDate, endTime);

    if (!start || !end) return false;
    if (start <= new Date()) return false;
    if (start >= end) return false;

    return minutesOfDay(endTime) - minutesOfDay(startTime) >= 60;
};
